/** Base64 without the data-URL prefix, which is what the API wants. */
export async function toBase64(file: File): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = "";
  // Chunked: `String.fromCharCode(...bytes)` on a 10MB file blows the argument limit.
  const CHUNK = 0x8000;
  for (let index = 0; index < bytes.length; index += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(index, index + CHUNK));
  }
  return btoa(binary);
}

export const humanBytes = (bytes: number): string =>
  bytes < 1024 ? `${bytes} B` : bytes < 1024 * 1024 ? `${Math.round(bytes / 1024)} KB` : `${(bytes / 1024 / 1024).toFixed(1)} MB`;

/**
 * A public file link as something to paste anywhere: the server gives it absolute
 * when it knows its own address, else a path this page's origin goes in front of.
 */
export const absoluteFileUrl = (url: string): string => new URL(url, window.location.origin).href;

/** Puts a public file link on the clipboard and says so. */
export function copyFileLink(url: string, notify: { success: (text: string) => void; error: (text: string) => void }): void {
  void navigator.clipboard.writeText(absoluteFileUrl(url)).then(
    () => notify.success("Link copied"),
    () => notify.error("Could not copy the link"),
  );
}
